export const NETLIFY_PUBLISH = 'PUBLISH';
export const NETLIFY_DELETE = 'DELETE';
export const NETLIFY_PUBLISH_RENAMED = 'RENAME';
export const NETLIFY_PREVIEW = 'PREVIEW';
export const NETLIFY_UNPUBLISH = 'UNPUBLISH';